export enum Permission {
  AggregateStorePerformance = 'store_performance.view',
  HistoricalStorePerformance = 'historical_store_performance.view',
}
